// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSettingGoal')
class Toolbox__GoalSettingGoal {
    @jsonProperty(() => Toolbox__GoalSettingGoal.Id)
    id: Toolbox__GoalSettingGoal.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting_developmentGoal", "goalSetting_developmentGoalId", "goalSetting_performanceGoal", "goalSetting_performanceGoalId", "goalSetting_futureDevelopmentGoal", "goalSetting_futureDevelopmentGoalId", "goalSetting_futurePerformanceGoal", "goalSetting_futurePerformanceGoalId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting_developmentGoal", "goalSetting_developmentGoalId", "goalSetting_performanceGoal", "goalSetting_performanceGoalId", "goalSetting_futureDevelopmentGoal", "goalSetting_futureDevelopmentGoalId", "goalSetting_futurePerformanceGoal", "goalSetting_futurePerformanceGoalId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "order", "goalDescription", "rejectionComment", "selfRating", "managerRating", "goalSetting_developmentGoal", "goalSetting_developmentGoalId", "goalSetting_performanceGoal", "goalSetting_performanceGoalId", "goalSetting_futureDevelopmentGoal", "goalSetting_futureDevelopmentGoalId", "goalSetting_futurePerformanceGoal", "goalSetting_futurePerformanceGoalId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "order": "number", "goalDescription": "string", "rejectionComment": "string", "selfRating": "string", "managerRating": "string", "goalSetting_developmentGoal": "Toolbox.GoalSetting", "goalSetting_developmentGoalId": "Toolbox.GoalSetting.Id", "goalSetting_performanceGoal": "Toolbox.GoalSetting", "goalSetting_performanceGoalId": "Toolbox.GoalSetting.Id", "goalSetting_futureDevelopmentGoal": "Toolbox.GoalSetting", "goalSetting_futureDevelopmentGoalId": "Toolbox.GoalSetting.Id", "goalSetting_futurePerformanceGoal": "Toolbox.GoalSetting", "goalSetting_futurePerformanceGoalId": "Toolbox.GoalSetting.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "goalDescription"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ goalSetting_developmentGoal: () => Toolbox.GoalSetting, goalSetting_performanceGoal: () => Toolbox.GoalSetting, goalSetting_futureDevelopmentGoal: () => Toolbox.GoalSetting, goalSetting_futurePerformanceGoal: () => Toolbox.GoalSetting } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θorder = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θgoalDescription = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrejectionComment = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θselfRating = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θmanagerRating = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θgoalSetting_developmentGoal = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSetting_developmentGoalId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θgoalSetting_performanceGoal = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSetting_performanceGoalId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θgoalSetting_futureDevelopmentGoal = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSetting_futureDevelopmentGoalId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θgoalSetting_futurePerformanceGoal = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSetting_futurePerformanceGoalId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSettingGoal' {
        return 'Toolbox.GoalSettingGoal'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSettingGoal' {
        return 'Toolbox.GoalSettingGoal'
    }

    static get __baseType(): 'Toolbox.GoalSettingGoal' {
        return 'Toolbox.GoalSettingGoal'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSettingGoal' {
        return 'Toolbox.GoalSettingGoal'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSettingGoal[BoInfoSymbol]
    }

    get order(): number {
        return this.θorder?.()
    }

    set order(order) {
        this.θorder.set(LowgileDataUtil.coerceDataType(order, 'number', false, true))
    }

    get goalDescription(): string {
        return this.θgoalDescription?.()
    }

    set goalDescription(goalDescription) {
        this.θgoalDescription.set(LowgileDataUtil.coerceDataType(goalDescription, 'string', false, true))
    }

    get rejectionComment(): string {
        return this.θrejectionComment?.()
    }

    set rejectionComment(rejectionComment) {
        this.θrejectionComment.set(LowgileDataUtil.coerceDataType(rejectionComment, 'string', false, true))
    }

    get selfRating(): string {
        return this.θselfRating?.()
    }

    set selfRating(selfRating) {
        this.θselfRating.set(LowgileDataUtil.coerceDataType(selfRating, 'string', false, true))
    }

    get managerRating(): string {
        return this.θmanagerRating?.()
    }

    set managerRating(managerRating) {
        this.θmanagerRating.set(LowgileDataUtil.coerceDataType(managerRating, 'string', false, true))
    }

    get goalSetting_developmentGoal(): Toolbox.GoalSetting {
        return this.θgoalSetting_developmentGoal?.()
    }

    set goalSetting_developmentGoal(goalSetting_developmentGoal) {
        this.θgoalSetting_developmentGoal.set(LowgileDataUtil.coerceDataType(goalSetting_developmentGoal, Toolbox.GoalSetting, false, true))
        if (goalSetting_developmentGoal) {
            this.θgoalSetting_developmentGoalId.set(goalSetting_developmentGoal.id)
        } else if (goalSetting_developmentGoal === null && goalSetting_developmentGoal) {
            this.θgoalSetting_developmentGoalId.set(null)
        }
    }

    get goalSetting_developmentGoalId(): Toolbox.GoalSetting.Id {
        return this.θgoalSetting_developmentGoalId?.()
    }

    set goalSetting_developmentGoalId(goalSetting_developmentGoalId) {
        if (goalSetting_developmentGoalId === null) this.θgoalSetting_developmentGoal.set(null)
        if (this.goalSetting_developmentGoal?.id && goalSetting_developmentGoalId != this.goalSetting_developmentGoal.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSetting_developmentGoalId.set(LowgileDataUtil.coerceDataType(goalSetting_developmentGoalId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get goalSetting_performanceGoal(): Toolbox.GoalSetting {
        return this.θgoalSetting_performanceGoal?.()
    }

    set goalSetting_performanceGoal(goalSetting_performanceGoal) {
        this.θgoalSetting_performanceGoal.set(LowgileDataUtil.coerceDataType(goalSetting_performanceGoal, Toolbox.GoalSetting, false, true))
        if (goalSetting_performanceGoal) {
            this.θgoalSetting_performanceGoalId.set(goalSetting_performanceGoal.id)
        } else if (goalSetting_performanceGoal === null && goalSetting_performanceGoal) {
            this.θgoalSetting_performanceGoalId.set(null)
        }
    }

    get goalSetting_performanceGoalId(): Toolbox.GoalSetting.Id {
        return this.θgoalSetting_performanceGoalId?.()
    }

    set goalSetting_performanceGoalId(goalSetting_performanceGoalId) {
        if (goalSetting_performanceGoalId === null) this.θgoalSetting_performanceGoal.set(null)
        if (this.goalSetting_performanceGoal?.id && goalSetting_performanceGoalId != this.goalSetting_performanceGoal.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSetting_performanceGoalId.set(LowgileDataUtil.coerceDataType(goalSetting_performanceGoalId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get goalSetting_futureDevelopmentGoal(): Toolbox.GoalSetting {
        return this.θgoalSetting_futureDevelopmentGoal?.()
    }

    set goalSetting_futureDevelopmentGoal(goalSetting_futureDevelopmentGoal) {
        this.θgoalSetting_futureDevelopmentGoal.set(LowgileDataUtil.coerceDataType(goalSetting_futureDevelopmentGoal, Toolbox.GoalSetting, false, true))
        if (goalSetting_futureDevelopmentGoal) {
            this.θgoalSetting_futureDevelopmentGoalId.set(goalSetting_futureDevelopmentGoal.id)
        } else if (goalSetting_futureDevelopmentGoal === null && goalSetting_futureDevelopmentGoal) {
            this.θgoalSetting_futureDevelopmentGoalId.set(null)
        }
    }

    get goalSetting_futureDevelopmentGoalId(): Toolbox.GoalSetting.Id {
        return this.θgoalSetting_futureDevelopmentGoalId?.()
    }

    set goalSetting_futureDevelopmentGoalId(goalSetting_futureDevelopmentGoalId) {
        if (goalSetting_futureDevelopmentGoalId === null) this.θgoalSetting_futureDevelopmentGoal.set(null)
        if (this.goalSetting_futureDevelopmentGoal?.id && goalSetting_futureDevelopmentGoalId != this.goalSetting_futureDevelopmentGoal.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSetting_futureDevelopmentGoalId.set(LowgileDataUtil.coerceDataType(goalSetting_futureDevelopmentGoalId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get goalSetting_futurePerformanceGoal(): Toolbox.GoalSetting {
        return this.θgoalSetting_futurePerformanceGoal?.()
    }

    set goalSetting_futurePerformanceGoal(goalSetting_futurePerformanceGoal) {
        this.θgoalSetting_futurePerformanceGoal.set(LowgileDataUtil.coerceDataType(goalSetting_futurePerformanceGoal, Toolbox.GoalSetting, false, true))
        if (goalSetting_futurePerformanceGoal) {
            this.θgoalSetting_futurePerformanceGoalId.set(goalSetting_futurePerformanceGoal.id)
        } else if (goalSetting_futurePerformanceGoal === null && goalSetting_futurePerformanceGoal) {
            this.θgoalSetting_futurePerformanceGoalId.set(null)
        }
    }

    get goalSetting_futurePerformanceGoalId(): Toolbox.GoalSetting.Id {
        return this.θgoalSetting_futurePerformanceGoalId?.()
    }

    set goalSetting_futurePerformanceGoalId(goalSetting_futurePerformanceGoalId) {
        if (goalSetting_futurePerformanceGoalId === null) this.θgoalSetting_futurePerformanceGoal.set(null)
        if (this.goalSetting_futurePerformanceGoal?.id && goalSetting_futurePerformanceGoalId != this.goalSetting_futurePerformanceGoal.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSetting_futurePerformanceGoalId.set(LowgileDataUtil.coerceDataType(goalSetting_futurePerformanceGoalId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSettingGoal>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSettingGoal()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSettingGoal>, restrictToClass?: Class<Partial<Toolbox__GoalSettingGoal>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            order: z.number(),
            goalDescription: z.string(),
            rejectionComment: z.string(),
            selfRating: z.string(),
            managerRating: z.string(),
            get goalSetting_developmentGoal() { return Toolbox.GoalSetting.$getSchema() },
            get goalSetting_developmentGoalId() { return z.number() },
            get goalSetting_performanceGoal() { return Toolbox.GoalSetting.$getSchema() },
            get goalSetting_performanceGoalId() { return z.number() },
            get goalSetting_futureDevelopmentGoal() { return Toolbox.GoalSetting.$getSchema() },
            get goalSetting_futureDevelopmentGoalId() { return z.number() },
            get goalSetting_futurePerformanceGoal() { return Toolbox.GoalSetting.$getSchema() },
            get goalSetting_futurePerformanceGoalId() { return z.number() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSettingGoal.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('order', 'goalDescription', 'rejectionComment', 'selfRating', 'managerRating', 'goalSetting_developmentGoal', 'goalSetting_developmentGoalId', 'goalSetting_performanceGoal', 'goalSetting_performanceGoalId', 'goalSetting_futureDevelopmentGoal', 'goalSetting_futureDevelopmentGoalId', 'goalSetting_futurePerformanceGoal', 'goalSetting_futurePerformanceGoalId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    getGoalSettingId(): This.GoalSetting.Id {
        return this.goalSetting_developmentGoalId
            || this.goalSetting_performanceGoalId
            || this.goalSetting_futureDevelopmentGoalId
            || this.goalSetting_futurePerformanceGoalId
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSettingGoal {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSettingGoal { }

export import GoalSettingGoal = Toolbox__GoalSettingGoal
setTimeout(() => {
    jsonProperty(() => Number)(Toolbox__GoalSettingGoal.prototype, 'order')
    jsonProperty(() => String)(Toolbox__GoalSettingGoal.prototype, 'goalDescription')
    jsonProperty(() => String)(Toolbox__GoalSettingGoal.prototype, 'rejectionComment')
    jsonProperty(() => String)(Toolbox__GoalSettingGoal.prototype, 'selfRating')
    jsonProperty(() => String)(Toolbox__GoalSettingGoal.prototype, 'managerRating')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_developmentGoal')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_developmentGoalId')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_performanceGoal')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_performanceGoalId')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_futureDevelopmentGoal')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_futureDevelopmentGoalId')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_futurePerformanceGoal')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingGoal.prototype, 'goalSetting_futurePerformanceGoalId')
    jsonProperty(() => Date)(Toolbox__GoalSettingGoal.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingGoal.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingGoal.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingGoal.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingGoal.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingGoal.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSettingGoal.prototype, 'versionNumber')
})

export const GoalSettingGoalθId = Number;

export type GoalSettingGoalθId = number;

namespace Toolbox__GoalSettingGoal {
    export type Id = NominalType<number, 'Toolbox.GoalSettingGoal'>

}
